import { EMAIL, WEB_PUSH } from 'constants/messageMediums';
import { EmailIframe, WebPushIframe, MobileIframe } from './TemplatePreview.styled';

export const renderIframe = (messageMedium) => {
  switch (messageMedium) {
    case EMAIL:
      return EmailIframe;
    case WEB_PUSH:
      return WebPushIframe;
    default:
      // SMS, PUSH
      return MobileIframe;
  }
};
